<div class="mb-6">
    @if (title()) {
        <div class="text-sm text-[var(--element-ui-2)] mb-4">
            {{ title() | translate }}
            <!-- {{ required() ? '*' : '' }} -->
        </div>
    }

    @if (description()) {
        <p class="mb-3 text-sm text-[var(--element-ui-2)]">{{ description() | translate }}</p>
    }

    <div class="grid gap-4 md:grid-cols-2 md:items-start">
        <div>
            <tran-custom-value-select-field
                label="components.kpi-selector.kpi"
                placeholder="components.kpi-selector.kpi-placeholder"
                displayProperty="name"
                displayTranslationPrefix="kpis."
                [formControl]="form().controls.selection"
                [options]="sortedKpis()"
                [required]="form().controls.selection.hasValidator(requiredValidator)"
                [readonly]="readonly()"
                [maxSelected]="1"
                [errorMapper]="{ required: 'application-form.required' | translate }"
            />
        </div>

        <tran-textarea-field
            label="components.kpi-selector.definition"
            placeholder="components.kpi-selector.definition-placeholder"
            textareaHeightClass="h-8"
            [formControl]="form().controls.definition"
            [readonly]="readonly()"
            [errorMapper]="{ required: 'components.kpi-selector.definition-required' | translate }"
        />

        <si-form-item
            [label]="'components.kpi-selector.start-value' | translate"
            [required]="form().controls.startValue.hasValidator(requiredValidator)"
            [formErrorMapper]="{ required: 'application-form.required' | translate }"
        >
            <tran-number-input
                class="form-control text-start"
                inputId="kpi-start-value"
                [min]="0"
                [step]="1"
                [formControl]="form().controls.startValue"
                [attr.aria-required]="form().controls.startValue.hasValidator(requiredValidator)"
                [required]="form().controls.startValue.hasValidator(requiredValidator)"
                [disabled]="readonly()"
            />
        </si-form-item>
        <si-form-item
            [label]="'components.kpi-selector.start-value-unit' | translate"
            [required]="form().controls.startValueUnit.hasValidator(requiredValidator)"
            [formErrorMapper]="{ required: 'application-form.required' | translate }"
        >
            <si-select
                hasFilter
                class="form-control"
                [options]="unitOptions()"
                [formControl]="form().controls.startValueUnit"
                [readonly]="readonly()"
            >
                <ng-template siSelectOptionTemplate let-option>
                    {{ option.label | translate }} ({{ unitSymbol(option.value) }})
                </ng-template>
            </si-select>
        </si-form-item>
        <si-form-item
            [label]="'components.kpi-selector.target-value' | translate"
            [required]="form().controls.targetValue.hasValidator(requiredValidator)"
            [formErrorMapper]="{ required: 'application-form.required' | translate }"
        >
            <tran-number-input
                class="form-control text-start"
                inputId="kpi-target-value"
                [min]="0"
                [step]="1"
                [formControl]="form().controls.targetValue"
                [attr.aria-required]="form().controls.targetValue.hasValidator(requiredValidator)"
                [required]="form().controls.targetValue.hasValidator(requiredValidator)"
                [disabled]="readonly()"
            />
        </si-form-item>
        <si-form-item
            [label]="'components.kpi-selector.target-value-unit' | translate"
            [required]="form().controls.targetValueUnit.hasValidator(requiredValidator)"
            [formErrorMapper]="{ required: 'application-form.required' | translate }"
        >
            <si-select
                hasFilter
                class="form-control"
                [options]="unitOptions()"
                [formControl]="form().controls.targetValueUnit"
                [readonly]="readonly()"
            >
                <ng-template siSelectOptionTemplate let-option>
                    {{ option.label | translate }} ({{ unitSymbol(option.value) }})
                </ng-template>
            </si-select>
        </si-form-item>
    </div>
</div>
